import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [{
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {
        title: '首页',
        icon: 'home'
      }
    }]
  }
]

export const asyncRouterMap = [{
    path: '/pms',
    component: Layout,
    redirect: '/pms/product',
    name: 'pms',
    meta: {
      title: '商品',
      icon: 'product'
    },
    children: [{
        path: 'product',
        name: 'product',
        component: () => import('@/views/pms/product/index'),
        meta: {
          title: '商品列表',
          icon: 'product-list'
        }
      },
      {
        path: 'addProduct',
        name: 'addProduct',
        component: () => import('@/views/pms/product/add'),
        meta: {
          title: '添加商品',
          icon: 'product-add'
        }
      },
      {
        path: 'updateProduct',
        name: 'updateProduct',
        component: () => import('@/views/pms/product/update'),
        meta: {
          title: '修改商品',
          icon: 'product-add'
        },
        hidden: true
      },
      {
        path: 'productCate',
        name: 'productCate',
        component: () => import('@/views/pms/productCate/index'),
        meta: {
          title: '商品分类',
          icon: 'product-cate'
        }
      },
      {
        path: 'addProductCate',
        name: 'addProductCate',
        component: () => import('@/views/pms/productCate/add'),
        meta: {
          title: '添加商品分类'
        },
        hidden: true
      },
      {
        path: 'updateProductCate',
        name: 'updateProductCate',
        component: () => import('@/views/pms/productCate/update'),
        meta: {
          title: '修改商品分类'
        },
        hidden: true
      },
      {
        path: 'productAttr',
        name: 'productAttr',
        component: () => import('@/views/pms/productAttr/index'),
        meta: {
          title: '商品类型',
          icon: 'product-attr'
        }
      },
      {
        path: 'productAttrList',
        name: 'productAttrList',
        component: () => import('@/views/pms/productAttr/productAttrList'),
        meta: {
          title: '商品属性列表'
        },
        hidden: true
      },
      {
        path: 'addProductAttr',
        name: 'addProductAttr',
        component: () => import('@/views/pms/productAttr/addProductAttr'),
        meta: {
          title: '添加商品属性'
        },
        hidden: true
      },
      {
        path: 'updateProductAttr',
        name: 'updateProductAttr',
        component: () => import('@/views/pms/productAttr/updateProductAttr'),
        meta: {
          title: '修改商品属性'
        },
        hidden: true
      },
      {
        path: 'brand',
        name: 'brand',
        component: () => import('@/views/pms/brand/index'),
        meta: {
          title: '品牌管理',
          icon: 'product-brand'
        }
      },
      {
        path: 'addBrand',
        name: 'addBrand',
        component: () => import('@/views/pms/brand/add'),
        meta: {
          title: '添加品牌'
        },
        hidden: true
      },
      {
        path: 'updateBrand',
        name: 'updateBrand',
        component: () => import('@/views/pms/brand/update'),
        meta: {
          title: '编辑品牌'
        },
        hidden: true
      }
    ]
  },
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: {
      title: '订单',
      icon: 'order',
    },
    children: [{
        path: 'order',
        name: 'orderList',
        component: () => import('@/views/oms/order/index'),
        meta: {
          noCache: false,
          title: '用户订单',
          icon: 'product-list'
        }
      },
      {
        path: 'item',
        name: 'orderItem',
        component: () => import('@/views/oms/order/item'),
        meta: {
          title: '商品订单',
          icon: 'product-list'
        }
      },
      {
        path: 'fakeOrder',
        name: 'fakeorderList',
        component: () => import('@/views/oms/fakeOrder/index'),
        meta: {
          title: '虚拟做单',
          icon: 'product-list'
        }
      },
      {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/oms/order/orderDetail'),
        meta: {
          title: '订单详情'
        },
        hidden: true
      },
      {
        path: 'deliverOrderList',
        name: 'deliverOrderList',
        component: () => import('@/views/oms/order/deliverOrderList'),
        meta: {
          title: '发货列表'
        },
        hidden: true
      },
      {
        path: 'orderSetting',
        name: 'orderSetting',
        component: () => import('@/views/oms/order/setting'),
        meta: {
          title: '订单设置',
          icon: 'order-setting'
        }
      },
      {
        path: 'returnApply',
        name: 'returnApply',
        component: () => import('@/views/oms/apply/index'),
        meta: {
          title: '退货申请处理',
          icon: 'order-return'
        }
      },
      {
        path: 'returnReason',
        name: 'returnReason',
        component: () => import('@/views/oms/apply/reason'),
        meta: {
          title: '退货原因设置',
          icon: 'order-return-reason'
        }
      },
      {
        path: 'returnApplyDetail',
        name: 'returnApplyDetail',
        component: () => import('@/views/oms/apply/applyDetail'),
        meta: {
          title: '退货原因详情'
        },
        hidden: true
      },
      {
        path: 'payway',
        name: 'payway',
        component: () => import('@/views/oms/payway'),
        meta: {
          title: '支付通道'
        },
        hidden: true
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    redirect: '/user/user_list',
    name: 'user',
    meta: {
      title: '用户',
      icon: 'users'
    },
    children: [{
        path: 'user_list',
        name: 'homeuser_list',
        component: () => import('@/views/user/user_list/index'),
        meta: {
          title: '用户列表',
          icon: 'user_list'
        }
      },
      {
        path: 'user_info',
        name: 'homeuser_info',
        component: () => import('@/views/user/user_info/index'),
        meta: {
          title: '用户详情'
        },
        hidden: true
      },
      {
        path: 'user_tree',
        name: 'homeuser_tree',
        component: () => import('@/views/user/user_tree/index'),
        meta: {
          title: '用户树',
          icon: 'user_tree'
        }
      },
      {
        path: 'user_recharge',
        name: 'homeuser_recharge',
        component: () => import('@/views/user/user_recharge/index'),
        meta: {
          title: '线下充值',
          icon: 'recharge'
        }
      },
      // {
      //   path: 'memberLevel',
      //   name: 'memberLevel',
      //   component: () => import('@/views/user/memberLevel/index'),
      //   meta: {title: '会员等级', icon: 'recharge'}
      // },
      {
        path: 'member_level',
        name: 'homemember_level',
        component: () => import('@/views/user/member_level/index'),
        meta: {
          title: '会员等级',
          icon: 'level'
        }
      },
      {
        path: 'member_money_log',
        name: 'homemember_money_log',
        component: () => import('@/views/user/member_money_log/index'),
        meta: {
          title: '余额日志',
          icon: 'diary'
        }
      },
      {
        path: 'member_amount_log',
        name: 'homemember_amount_log',
        component: () => import('@/views/user/member_amount_log/index'),
        meta: {
          title: '贡献值日志',
          icon: 'diary'
        }
      },
      {
        path: 'member_point_log',
        name: 'homemember_point_log',
        component: () => import('@/views/user/member_point_log/index'),
        meta: {
          title: '积分日志',
          icon: 'diary'
        }
      },
      {
        path: 'menber_jewel_log',
        name: 'homemember_jewel_log',
        component: () => import('@/views/user/menber_jewel_log/index'),
        meta: {
          title: '消费券日志',
          icon: 'diary'
        }
      },
      {
        path: 'bonusList',
        name: 'bonusList',
        component: () => import('@/views/user/bonus/index'),
        meta: {
          title: '奖金池记录',
          icon: 'recharge'
        }
      },
      {
        path: 'region',
        name: 'region',
        component: () => import('@/views/user/region/region'),
        meta: {
          title: '行政区域',
          icon: 'level'
        }
      },
      {
        path: 'memberPower',
        name: 'memberPower',
        component: () => import('@/views/user/memberPower/index'),
        meta: {
          title: '操作权限',
          icon: 'agent'
        }
      }, {
        path: 'withdrawal_record',
        name: 'withdrawal_record',
        component: () => import('@/views/user/withdrawal_record/index'),
        meta: {
          title: '提现记录',
          icon: 'diary'
        }
      }, {
        path: 'prizePool',
        name: 'prizePool',
        component: () => import('@/views/user/prize_pool/index'),
        meta: {
          title: '分红审核',
          icon: 'diary'
        }
      },
	  {
	    path: 'teamPerformance',
	    name: 'teamPerformance',
	    component: () => import('@/views/user/teamPerformance/index'),
	    meta: {
	      title: '团队业绩管理',
	      icon: 'team-performance'
	    }
	  },
	  {
	    path: 'weeklyDividend',
	    name: 'weeklyDividend',
	    component: () => import('@/views/user/weeklyDividend/index'),
	    meta: { title: '周分红记录', icon: 'money' }
	  }
      // {
      //   path: 'addsubject',
      //   name: 'addHomesubject',
      //   component: () => import('@/views/sub/subject_list/add'),
      //   meta: {title: '添加专题'},
      //   hidden:true
      // },
      // {
      //   path: 'updatesubject',
      //   name: 'updateHomesubject',
      //   component: () => import('@/views/sub/subject_list/update'),
      //   meta: {title: '编辑专题'},
      //   hidden:true
      // },
      // {
      //   path: 'addsubject_category',
      //   name: 'addHomesubject_category',
      //   component: () => import('@/views/sub/subject_category/add'),
      //   meta: {title: '添加分类'},
      //   hidden:true
      // },
      // {
      //   path: 'updatesubject_category',
      //   name: 'updateHomesubject_category',
      //   component: () => import('@/views/sub/subject_category/update'),
      //   meta: {title: '编辑分类'},
      //   hidden:true
      // },

    ]
  },
  {
    path: '/mplive',
    component: Layout,
    redirect: '/mplive/manger',
    name: 'mplive',
    meta: {
      title: '商家券',
      icon: 'money',
    },
    children: [{
        path: 'manger',
        name: 'liveManger',
        component: () => import('@/views/live/manger/index'),
        meta: {
          noCache: false,
          title: '直播间',
          icon: 'nested'
        }
      },

      {
        path: 'liveLog',
        name: 'liveLog',
        component: () => import('@/views/live/log/index'),
        meta: {
          noCache: false,
          title: '进播记录',
          icon: 'nested'
        }
      }, {
        path: 'cls',
        name: 'busifavorCls',
        component: () => import('@/views/busifavor/cls/index'),
        meta: {
          noCache: false,
          title: '分类',
          icon: 'nested'
        }
      },
      {
        path: 'stock',
        name: 'busifavorStock',
        component: () => import('@/views/busifavor/stock/index'),
        meta: {
          noCache: false,
          title: '商家券批次',
          icon: 'nested'
        }
      },
      {
        path: 'stockAdd',
        name: 'busifavorStockAdd',
        component: () => import('@/views/busifavor/stock/add'),
        meta: {
          title: '商家券批次添加'
        },
        hidden: true
      },
      {
        path: 'coupon',
        name: 'busifavorCoupon',
        component: () => import('@/views/busifavor/coupon/index'),
        meta: {
          noCache: false,
          title: '用户领取',
          icon: 'nested'
        }
      },
    ]
  },
  {
    path: '/sms',
    component: Layout,
    redirect: '/sms/coupon',
    name: 'sms',
    meta: {
      title: '营销',
      icon: 'sms'
    },
    children: [{
        path: 'liveDraw',
        name: 'liveDraw',
        component: () => import('@/views/live/draw'),
        meta: {
          title: '直播中奖',
          icon: 'sms-subject'
        }
      }, {
        path: 'talent',
        name: 'talent',
        component: () => import('@/views/sms/talent/index'),
        meta: {
          title: '达人说审核',
          icon: 'sms-subject'
        }
      },
      {
        path: 'article',
        name: 'article',
        component: () => import('@/views/sms/article/index'),
        meta: {
          title: '文章管理',
          icon: 'sms-subject'
        }
      },
      {
        path: 'flash',
        name: 'flash',
        component: () => import('@/views/sms/flash/index'),
        meta: {
          title: '秒杀活动列表',
          icon: 'sms-flash'
        }
      },
      {
        path: 'flashSession',
        name: 'flashSession',
        component: () => import('@/views/sms/flash/sessionList'),
        meta: {
          title: '秒杀时间段列表'
        },
        hidden: true
      },
      {
        path: 'selectSession',
        name: 'selectSession',
        component: () => import('@/views/sms/flash/selectSessionList'),
        meta: {
          title: '秒杀时间段选择'
        },
        hidden: true
      },
      {
        path: 'flashProductRelation',
        name: 'flashProductRelation',
        component: () => import('@/views/sms/flash/productRelationList'),
        meta: {
          title: '秒杀商品列表'
        },
        hidden: true
      },
      {
        path: 'coupon',
        name: 'coupon',
        component: () => import('@/views/sms/coupon/index'),
        meta: {
          title: '优惠券列表',
          icon: 'sms-coupon'
        }
      },
      {
        path: 'addCoupon',
        name: 'addCoupon',
        component: () => import('@/views/sms/coupon/add'),
        meta: {
          title: '添加优惠券'
        },
        hidden: true
      },
      {
        path: 'updateCoupon',
        name: 'updateCoupon',
        component: () => import('@/views/sms/coupon/update'),
        meta: {
          title: '修改优惠券'
        },
        hidden: true
      },
      {
        path: 'couponHistory',
        name: 'couponHistory',
        component: () => import('@/views/sms/coupon/history'),
        meta: {
          title: '优惠券领取详情'
        },
        hidden: true
      },
      {
        path: 'brand',
        name: 'homeBrand',
        component: () => import('@/views/sms/brand/index'),
        meta: {
          title: '品牌推荐',
          icon: 'product-brand'
        }
      },
      {
        path: 'new',
        name: 'homeNew',
        component: () => import('@/views/sms/new/index'),
        meta: {
          title: '新品推荐',
          icon: 'sms-new'
        }
      },
      {
        path: 'hot',
        name: 'homeHot',
        component: () => import('@/views/sms/hot/index'),
        meta: {
          title: '人气推荐',
          icon: 'sms-hot'
        }
      },
      {
        path: 'subject',
        name: 'homeSubject',
        component: () => import('@/views/sms/subject/index'),
        meta: {
          title: '专题推荐',
          icon: 'sms-subject'
        }
      },
      // {
      //   path: 'subject_list',
      //   name: 'homesubject_list',
      //   component: () => import('@/views/sms/subject_list/index'),
      //   meta: {title: '专题列表', icon: 'sms-subject_list'}
      // },
      // {
      //   path: 'subject_category',
      //   name: 'homesubject_category',
      //   component: () => import('@/views/sms/subject_category/index'),
      //   meta: {title: '专题分类', icon: 'sms-subject_category'}
      // },
      {
        path: 'advertise',
        name: 'homeAdvertise',
        component: () => import('@/views/sms/advertise/index'),
        meta: {
          title: '广告列表',
          icon: 'sms-ad'
        }
      },
      {
        path: 'addAdvertise',
        name: 'addHomeAdvertise',
        component: () => import('@/views/sms/advertise/add'),
        meta: {
          title: '添加广告'
        },
        hidden: true
      },
      {
        path: 'updateAdvertise',
        name: 'updateHomeAdvertise',
        component: () => import('@/views/sms/advertise/update'),
        meta: {
          title: '编辑广告'
        },
        hidden: true
      },
      // {
      //   path: 'addsubject',
      //   name: 'addHomesubject',
      //   component: () => import('@/views/sms/subject_list/add'),
      //   meta: {title: '添加专题'},
      //   hidden:true
      // },
      // {
      //   path: 'updatesubject',
      //   name: 'updateHomesubject',
      //   component: () => import('@/views/sms/subject_list/update'),
      //   meta: {title: '编辑专题'},
      //   hidden:true
      // },
      // {
      //   path: 'addsubject_category',
      //   name: 'addHomesubject_category',
      //   component: () => import('@/views/sms/subject_category/add'),
      //   meta: {title: '添加分类'},
      //   hidden:true
      // },
      // {
      //   path: 'updatesubject_category',
      //   name: 'updateHomesubject_category',
      //   component: () => import('@/views/sms/subject_category/update'),
      //   meta: {title: '编辑分类'},
      //   hidden:true
      // },

    ]
  },
  {
    path: '/sub',
    component: Layout,
    redirect: '/sub/subject_list',
    name: 'sub',
    meta: {
      title: '专题',
      icon: 'sub'
    },
    children: [{
        path: 'subject_list',
        name: 'homesubject_list',
        component: () => import('@/views/sub/subject_list/index'),
        meta: {
          title: '专题列表',
          icon: 'sms-subject_list'
        }
      },
      {
        path: 'subject_category',
        name: 'homesubject_category',
        component: () => import('@/views/sub/subject_category/index'),
        meta: {
          title: '专题分类',
          icon: 'sms-subject_category'
        }
      },
      {
        path: 'addsubject',
        name: 'addHomesubject',
        component: () => import('@/views/sub/subject_list/add'),
        meta: {
          title: '添加专题'
        },
        hidden: true
      },
      {
        path: 'updatesubject',
        name: 'updateHomesubject',
        component: () => import('@/views/sub/subject_list/update'),
        meta: {
          title: '编辑专题'
        },
        hidden: true
      },
      {
        path: 'addsubject_category',
        name: 'addHomesubject_category',
        component: () => import('@/views/sub/subject_category/add'),
        meta: {
          title: '添加分类'
        },
        hidden: true
      },
      {
        path: 'updatesubject_category',
        name: 'updateHomesubject_category',
        component: () => import('@/views/sub/subject_category/update'),
        meta: {
          title: '编辑分类'
        },
        hidden: true
      },

    ]
  },
  {
    path: '/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {
      title: '权限',
      icon: 'ums'
    },
    children: [{
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {
          title: '管理员列表',
          icon: 'ums-admin'
        }
      },
      {
        path: 'language',
        name: 'language',
        component: () => import('@/views/ums/language/index'),
        meta: {
          title: '语言配置',
          icon: 'ums-admin'
        }
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {
          title: '角色列表',
          icon: 'ums-role'
        }
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {
          title: '分配菜单'
        },
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {
          title: '分配资源'
        },
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {
          title: '菜单列表',
          icon: 'ums-menu'
        }
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {
          title: '添加菜单'
        },
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {
          title: '修改菜单'
        },
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {
          title: '资源列表',
          icon: 'ums-resource'
        }
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {
          title: '资源分类'
        },
        hidden: true
      },
      {
        path: 'editUserInfo',
        name: 'editUserInfo',
        component: () => import('@/views/ums/editUserInfo'),
        meta: {
          title: '个人资料'
        },
        hidden: true
      },
      {
        path: 'versionUpdate',
        name: 'versionUpdate',
        component: () => import('@/views/ums/versionUpdate'),
        meta: {
          title: 'APP版本升级'
        },
        hidden: true
      },
      {
        path: 'systemConfigManage',
        name: 'systemConfigManage',
        component: () => import('@/views/ums/config/config'),
        meta: {
          title: '系统配置管理'
        },
        hidden: true
      },
      {
        path: 'systemConfig',
        name: 'systemConfig',
        component: () => import('@/views/ums/config/index'),
        meta: {
          title: '系统配置'
        },
        hidden: true
      }
    ]
  },
  {
    path: '/agent',
    component: Layout,
    redirect: '/agent/agent',
    name: 'agent',
    meta: {
      title: '代理商',
      icon: 'agent'
    },
    children: [{
        path: 'platform',
        name: 'platform',
        component: () => import('@/views/agent/platform/index'),
        meta: {
          title: '平台管理',
          icon: 'agent'
        }
      }, {
        path: 'store',
        name: 'store',
        component: () => import('@/views/agent/store/index'),
        meta: {
          noCache: false,
          title: '门店管理',
          icon: 'nested'
        }
      },
      {
        path: 'addPlatform',
        name: 'addPlatform',
        component: () => import('@/views/agent/platform/add'),
        meta: {
          title: '添加平台'
        },
        hidden: true
      }, {
        path: 'updatePlatform',
        name: 'updatePlatform',
        component: () => import('@/views/agent/platform/update'),
        meta: {
          title: '更新平台'
        },
        hidden: true
      }, {
        path: 'agent',
        name: 'agent_list',
        component: () => import('@/views/agent/agent/index'),
        meta: {
          title: '代理商',
          icon: 'agent'
        }
      },
      {
        path: 'addAgent',
        name: 'addAgent',
        component: () => import('@/views/agent/agent/add'),
        meta: {
          title: '添加代理商'
        },
        hidden: true
      },
      {
        path: 'updateAgent',
        name: 'updateAgent',
        component: () => import('@/views/agent/agent/update'),
        meta: {
          title: '编辑代理商'
        },
        hidden: true
      },
      {
        path: 'regionAgent',
        name: 'regionAgent',
        component: () => import('@/views/agent/regionAgent/index'),
        meta: {
          title: '区域代理（老版）',
          icon: 'agent'
        }
      },
      {
        path: 'areaAgent',
        name: 'areaAgent',
        component: () => import('@/views/agent/areaAgent/index'),
        meta: {
          title: '省市区代理管理',
          icon: 'el-icon-location-outline'
        }
      },
	  {
	    path: 'storeApplication',
	    name: 'storeApplication',
	    component: () => import('@/views/agent/storeApplication/index'),
	    meta: {
	      title: '提货门店管理',
	      icon: 'el-icon-location-outline'
	    }
	  },
	  {
		path: 'storeApplicationDetail',
		name: 'storeApplicationDetail',
		component: () => import('@/views/agent/storeApplication/detail'),
		meta: {
			title: '门店申请详情'
		},
		hidden: true
	},
	{
		path: 'pickupRecords',
		name: 'pickupRecords',
		component: () => import('@/views/agent/storeApplication/pickupRecords'),
		meta: {
		title: '提货记录管理',
			icon: 'el-icon-s-order'
		}
	}
    ]
  },
  // {
  //   path:'/regionAgent',
  //   component: Layout,
  //   redirect: '/regionAgent/regionAgent',
  //   name: 'regionAgent',
  //   meta: {title: '区域代理', icon: 'agent'},
  //   children: [
  //     {
  //       path: 'regionAgent',
  //       name: 'regionAgent',
  //       component: () => import('@/views/regionAgent/regionAgent/index'),
  //       meta: {title: '区域代理', icon: 'agent'}
  //     }
  //   ]
  // },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
})


// WEBPACK FOOTER //
// ./src/router/index.js